var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-chalkboard" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("about_the_company")) + "\n    ")
        ],
        1
      ),
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _vm._l(_vm.languages, function(l, index) {
            return _c("q-tab", {
              key: "t-" + index,
              attrs: { slot: "title", name: "tab-" + l.id, label: l.name },
              slot: "title"
            })
          }),
          _vm._l(_vm.languages, function(l, index) {
            return _c(
              "q-tab-pane",
              { key: "tp-" + index, attrs: { name: "tab-" + l.id } },
              [
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c(
                        "q-editor",
                        {
                          attrs: {
                            toolbar: [
                              ["bold", "italic", "strike", "underline"],
                              ["left", "center", "right", "justify"],
                              ["link", "upload"],
                              [
                                {
                                  label: null,
                                  icon: "fas fa-font",
                                  fixedLabel: true,
                                  fixedIcon: true,
                                  list: "no-icons",
                                  options: [
                                    "p",
                                    "h1",
                                    "h2",
                                    "h3",
                                    "h4",
                                    "h5",
                                    "h6",
                                    "code"
                                  ]
                                },
                                {
                                  label: null,
                                  icon: "fas fa-text-height",
                                  fixedLabel: true,
                                  fixedIcon: true,
                                  list: "no-icons",
                                  options: [
                                    "size-1",
                                    "size-2",
                                    "size-3",
                                    "size-4",
                                    "size-5",
                                    "size-6",
                                    "size-7"
                                  ]
                                },
                                "removeFormat"
                              ],
                              ["quote", "unordered", "ordered"],
                              ["custom_btn"]
                            ],
                            definitions: {
                              bold: { label: null, icon: "fas fa-bold" },
                              italic: { label: null, icon: "fas fa-italic" },
                              strike: {
                                label: null,
                                icon: "fas fa-strikethrough"
                              },
                              underline: {
                                label: null,
                                icon: "fas fa-underline"
                              },
                              left: { label: null, icon: "fas fa-align-left" },
                              center: {
                                label: null,
                                icon: "fas fa-align-center"
                              },
                              right: {
                                label: null,
                                icon: "fas fa-align-right"
                              },
                              justify: {
                                label: null,
                                icon: "fas fa-align-justify"
                              },
                              link: { label: null, icon: "fas fa-link" },
                              upload: {
                                tip: null,
                                icon: "fas fa-file-image",
                                handler: _vm.insertImg
                              },
                              removeFormat: {
                                label: null,
                                icon: "fas fa-eraser"
                              },
                              quote: {
                                label: null,
                                icon: "fas fa-quote-right"
                              },
                              unordered: {
                                label: null,
                                icon: "fas fa-list-ul"
                              },
                              ordered: { label: null, icon: "fas fa-list-ol" }
                            }
                          },
                          model: {
                            value: _vm.getAbout,
                            callback: function($$v) {
                              _vm.getAbout = $$v
                            },
                            expression: "getAbout"
                          }
                        },
                        [
                          _c("q-btn", {
                            attrs: {
                              slot: "custom_btn",
                              dense: "",
                              flat: "",
                              color: "black",
                              icon: "fal fa-code",
                              label: "HTML"
                            },
                            on: {
                              click: function($event) {
                                _vm.show_html = true
                              }
                            },
                            slot: "custom_btn"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.login_use_portfolio_page
                    ? _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "q-field",
                            { attrs: { count: 300 } },
                            [
                              _c("q-input", {
                                attrs: {
                                  "float-label": _vm.$t("portfolio_summary"),
                                  type: "textarea",
                                  rows: "3"
                                },
                                model: {
                                  value: _vm.getPortfolioDescription,
                                  callback: function($$v) {
                                    _vm.getPortfolioDescription = $$v
                                  },
                                  expression: "getPortfolioDescription"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.login_use_portfolio_page
                    ? _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("p", { staticClass: "caption" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("summary_portfolio_image")) +
                                "\n                    "
                            )
                          ]),
                          _c("uploader", {
                            attrs: {
                              content_type: "images",
                              multiple: false,
                              cropper: true,
                              aspect_ratio: 16 / 9,
                              aspect_ratio_string: "16/9"
                            },
                            on: {
                              fileUploaded: _vm.imageSummaryPortfolioUploaded
                            }
                          }),
                          _vm.getPortfolioImage
                            ? _c(
                                "p",
                                {
                                  ref: "image_summary_portfolio",
                                  refInFor: true,
                                  staticClass: "q-mt-md file-url"
                                },
                                [
                                  _c("q-icon", {
                                    attrs: {
                                      name: "fal fa-check",
                                      color: "positive"
                                    }
                                  }),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.getPortfolioImage,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$truncateLink(
                                              _vm.getPortfolioImage
                                            )
                                          )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            )
          })
        ],
        2
      ),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_overview" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_html,
            callback: function($$v) {
              _vm.show_html = $$v
            },
            expression: "show_html"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_html = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v("\n                    HTML\n                ")
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "textarea",
                          rows: "10",
                          "float-label": "HTML"
                        },
                        model: {
                          value: _vm.getAbout,
                          callback: function($$v) {
                            _vm.getAbout = $$v
                          },
                          expression: "getAbout"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("close"),
                            icon: "far fa-ban"
                          },
                          on: {
                            click: function($event) {
                              _vm.show_html = false
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }